import {
  ContentData,
  PromoBlock
} from '../constants/types/product-listing-page';
import Page from './page';
import { toImgix } from '~/util/imgix';

export type PageType = {
  contentData: ContentData;
};

export default class ProductListingPage extends Page {
  contentData: ContentData;

  constructor(props: PageType) {
    super(props);
    this.contentData = props.contentData;
  }

  get content() {
    return this.contentData.content;
  }

  get template() {
    return this.contentData.template;
  }

  get ecomAttribute() {
    return this.contentData.product_listing.ecom_attribute;
  }

  get ecomTitle() {
    return this.contentData.product_listing.ecom_attributes_title;
  }

  get ecomText() {
    return this.contentData.product_listing.ecom_attributes_text;
  }

  get ecomCategories() {
    return this.contentData.product_listing.ecom_categories;
  }

  get headerImageMobile() {
    return this.contentData.product_listing.header_image_mobile ? toImgix(this.contentData.product_listing.header_image_mobile) : '';
  }

  get headerImageDesktop() {
    return this.contentData.product_listing.header_image_desktop ? toImgix(this.contentData.product_listing.header_image_desktop) : '';
  }

  get headerTitle() {
    return this.contentData.product_listing.header_title;
  }

  get headerText() {
    return this.contentData.product_listing.header_text;
  }

  get headerLinks() {
    if (!Array.isArray(this.contentData.product_listing.header_links)) {
      return [];
    }
    return (
      this.contentData.product_listing?.header_links?.filter(
        (link) => link?.link?.url
      ) || []
    );
  }

  get headerLinksJs() {
    // eslint-disable-next-line camelcase
    return this.contentData.product_listing?.header_javascript_links ?? [];
  }

  get headerBackgroundColor() {
    return this.contentData.product_listing.header_background_color;
  }

  get showFilter() {
    return this.contentData.product_listing.show_filter;
  }

  get maxProducts() {
    return this.contentData.product_listing.max_products;
  }

  get promoBlocks() {
    const productBlocks = this.contentData.product_listing.promo_blocks || [];
    return productBlocks.map((block: PromoBlock) => {
      return {
        ...block,
        listType: 'promoBlock',
      };
    });
  }
}
